var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function (cents, format) {
  if (typeof cents == "string") {
    cents = cents.replace(".", "");
  }
  var value = "";
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || this.money_format;

  function defaultOption(opt, def) {
    return typeof opt == "undefined" ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ",");
    decimal = defaultOption(decimal, ".");

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split("."),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
      cents = parts[1] ? decimal + parts[1] : "";

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

if ($("#preloader").length > 0) {
  $(window).on("load", function () {
    $("#preloader")
      .delay(1000)
      .fadeOut(1000, function () {
        if ($(".preloader-overflow").length > 0) {
          $("body").removeClass("preloader-overflow");
        }
      });
  });
}
 
$(document).ready(function () {
    var Dwin = $(this); 
    if (Dwin.width() > 1024) {
      slickVeritcal();
    }
  else
    {
      slickHorizontal();
    }    
});
 
$(window).on('resize', function(){
    var win = $(this); 
    if (win.width() > 1024) {
      slickVeritcal();
    }
  else
    {
      slickHorizontal();
    }    
});

function slickVeritcal() {       
  if ($(".media-slick-slider  .thumbnail-list li").length > 6) {
  $(".thumbnail-list").not(".slick-initialized").slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    vertical:true,        
    focusOnSelect: true,
    verticalSwiping:true,
    responsive: [   
    {
      breakpoint: 1024,
      settings: {
        vertical: false,
      }
    },   
      {
      breakpoint: 1541,
      settings: {       
          slidesToShow: 3,
          slidesToScroll: 1
      }
    } 
    ]
  });

  }  
}
function slickHorizontal() {    
    if ($(".media-slick-slider  .thumbnail-list li").length > 5) {
      $(".thumbnail-list").slick("unslick");   
}
}

$(window).scroll(function () {
  if ($(window).width() > "1024") {
    if ($(window).scrollTop() >= 700) {      
      $(".sticky-bar").addClass("active");
    } else {       
      $(".sticky-bar").removeClass("active");
    }
  }
});

$(window).scroll(function () {
  if ($(window).width() < "1024") {
    if ($(window).scrollTop() >= 900) {      
      $(".sticky-bar").addClass("active");
    } else {       
      $(".sticky-bar").removeClass("active");
    }
  }
});

$(document).ready(function () {
  $("#recently").click(function () {
    $("#recently-viewed-products").slideToggle(500);
  });
});

var afterInfiniteLoaded = function afterInfiniteLoaded() {
  $(".loading-image").removeClass("loading-image").addClass("loaded-image");

  // Check if next pagination exists
  if ($("#AjaxinatePagination .noproducts").length > 0) {
    $("#AjaxinatePagination").remove(); // Remove pagination container when no more pages
  }
};


if ($(".pagination-method-loadmore_btn").length > 0) {
  var AjaxMethod = "click";
} else {
  var AjaxMethod = "scroll";
}
if ($(".collection #AjaxinatePagination").length > 0 && !$(".collection .noproducts").length) {
  var endlessScroll = new Ajaxinate({
    container: ".AjaxinateContainer",
    pagination: "#AjaxinatePagination",
    method: AjaxMethod,
    offset: 0,
    callback: afterInfiniteLoaded,
  });
}

InitCustomFunctions();
function InitCustomFunctions() {
  $('.facet-checkbox input:checkbox').each(function () {
  if($(this).is(':checked')){
       $(this).parent('.facet-checkbox').addClass('active');
    }     
  });
  

  
  if ($(".toggleFilter").length > 0) {
    const filter = document.querySelector(".toggleFilter");
    const sidebar = document.querySelector(".facets-vertical");
    const closeDiv = document.querySelector(".close-sidebar");

    filter.addEventListener("click", () => {
      filter.classList.toggle("active");
      sidebar.classList.toggle("open");
      $("body").addClass("overflow-hidden");
      $("body").addClass("filter-clicked");
    });

    closeDiv.addEventListener("click", () => {
      filter.classList.remove("active");
      sidebar.classList.remove("open");
      $("body").removeClass("overflow-hidden");
      $("body").removeClass("filter-clicked");
    });
  }

  //product page color variant to select thumbnail img change color_variants
  if ($(".show-grouped__variant").length > 0) {
    $('input:radio[name="Color"]').click(function () {
      const cvariant = $(this).val();
      $(this).closest('fieldset').find('.form__label span').text(cvariant);
      $('input:radio[name="Color"]')
        .next(".swatch-element")
        .removeClass("clicked");
      $(this).next(".swatch-element").addClass("clicked");
      $(".slick-list").addClass("height_fix");
      $(".thumbnail-list__item").each(function () {
        const variant_val = $(this).find("img").attr("alt");
        if (cvariant == variant_val) {
          $(this).addClass("show");
          $(this).removeClass("hidden");
        } else {
          $(this).addClass("hidden");
          $(this).removeClass("show");
        }
      });
    });
  }

  //     Item swatch trigger start
  $(document).on("click", ".color-values a", function () {
    if ($(this).hasClass("active")) {
      $(this).closest('.variant-option-color').find('.color-values a').removeClass("active");
    } else {
      $(this).closest('.variant-option-color').find('.color-values a').removeClass("active");
      $(this).addClass("active");
    }
  });

 $(document).on("click", ".size-values a", function () {
    if ($(this).hasClass("active")) {     
      $(this).closest(".variant-option-size").find(".size-values a").removeClass("active");
    } else {            
      $(this).closest(".variant-option-size").find(".size-values a").removeClass("active");
      $(this).addClass("active");
    }
  });
//  $("body").on("click", ".color-values-plus a", function (e) {
    $('.color-values-plus a').click(function(e) {
    $(this)
      .parents(".variant-option-color")
      .find(".show-on-click")
      .css("display", "flex");
    $(this).parents(".color-values-plus").css("display", "none");
    e.preventDefault();
  });

 
  //$("body").on("click", ".swatch span", function () {
   $('.swatch span').click(function(e) {
    var featuredMedia = $(this)
      .parents(".card-wrapper")
      .find(".card__inner .motion-reduce")
      .attr("srcset", $(this).data("image"));
    $(this)
      .parents(".card-wrapper")
      .find(".card__inner .motion-reduce")
      .attr("srcset", $(this).data("image"));

    if ($(this).parents(".swatch").hasClass("color")) {
      const variant = $(this).data("id");
      $(this).parents(".product-grid").find(".variant-push").val(variant);

      var swatch_item = $(this).data("variant-item");

      $(this)
        .parents(".product-grid")
        .find(".variant-option-size .size-values")
        .removeClass("active");
      $(this)
        .parents(".product-grid")
        .find(".variant-option-size .swatch")
        .each(function () {
          var swatch_size_vars = $(this).find("span").data("variant-title");
          swatch_size_vars = swatch_size_vars.split("/");
          swatch_size_vars = $.map(swatch_size_vars, $.trim);
          swatch_size_vars = $.map(swatch_size_vars, function (n) {
            return n.toLowerCase();
          });
          swatch_size_vars = $.map(swatch_size_vars, function (n) {
            return n.replace(/ /g, "-");
          });

          if ($.inArray(swatch_item, swatch_size_vars) >= 0) {
            $(this).parent(".size-values").toggleClass("active");
          }
        });
    }

    if ($(this).parents(".swatch").hasClass("size")) {
      var variant = $(this).data("id");
      $(this).parents(".product-grid").find(".variant-push").val(variant);
    }
  });
 
  //     Item swatch trigger end
  $(".custom-product-grid li").click(function () {
    var classNames ="list-view-filter grid--2-col-desktop grid--3-col-desktop grid--4-col-desktop grid--5-col-desktop grid--6-col-desktop align-1-column align-2-column align-3-column align-4-column align-5-column";
    var getCols = $(this).data("cols");
    var getVal = $(this).data("val");
    var getVal = "align-"+getVal+"-column";    
    $(".custom-product-grid li").removeClass("active");
    $(this).addClass("active");
    $("ul#product-grid").removeClass(classNames).addClass(getCols+" "+getVal);
  });
  if ($(".filter-buttons").length > 0) {
    const viewExists = document.querySelector(".grid-view-button");
    if (viewExists.classList.contains("layout-mode")) {
      const listViewButton = document.querySelector(".list-view-button");
      const gridViewButton = document.querySelector(".grid-view-button");
      const list = document.querySelector("ul.view-mode");
      const gridviewlist = document.querySelector(".custom-product-grid");

      listViewButton.onclick = function () {
        listViewButton.classList.add("active");
        gridViewButton.classList.remove("active");
        list.classList.remove("grid-view-filter");
        list.classList.add("list-view-filter");
        gridviewlist.classList.add("hidden");
      };

      gridViewButton.onclick = function () {
        listViewButton.classList.remove("active");
        gridViewButton.classList.add("active");
        list.classList.remove("list-view-filter");
        list.classList.add("grid-view-filter");
        gridviewlist.classList.remove("hidden");
      };
    }
  }
  if ($("#swiper-sidebar-carousel").length > 0) {
    var swiper = new Swiper("#swiper-sidebar-carousel", {
      navigation: {
        nextEl: "#swiper-sidebar-next",
        prevEl: "#swiper-sidebar-prev",
      },
    });
  }

  setTimeout(function () {
    $(".loading-image").removeClass("loading-image").addClass("loaded-image");
  }, 2000);

  const radioButtons = document.querySelectorAll('.dt-sort__container input[name="sort_by"]');
  const optionSummary = document.querySelector('.dt-sort__container .facets__summary-label');
  var selectedRadioButton;
  for (const radioButton of radioButtons) {
    if (radioButton.checked) {
      selectedRadioButton = radioButton.getAttribute("data-value");      
      optionSummary.textContent = selectedRadioButton;   
    }
  }
  
}


//FBT ul li select box
$("ul.custom-select").on("click", "li:not(.init)", function () {
  var selectedVal = $(this).data("option-value");  
  $(this)
    .parents(".fbt-product__meta")
    .find(".selectVariant option")
    .attr("selected", false);
  $(this)
    .parents(".fbt-product__meta")
    .find(".selectVariant option[value=" + selectedVal + "]")
    .attr("selected", "selected")
    .trigger("change");
});

$("ul.custom-select").on("click", ".init", function () {
  $(this).closest("ul.custom-select").children("li:not(.init)").toggle();
});

$("ul.custom-select").on("click", "li:not(.init)", function () {
  $(this).parent().children("li:not(.init)").removeClass("selected");
  $(this).addClass("selected");
  $(this).parent().children(".init").html($(this).html());
  $(this).parent().children(".init").removeClass("li-unselected");
  $(this).parent().children("li:not(.init)").toggle();
  if ($("ul.custom-select li.init").hasClass("li-unselected")) {
    $("#add-frequently-bought").prop("disabled", true);
  } else {
    $("#add-frequently-bought").prop("disabled", false);
  }
});
loadedBg();
function loadedBg() {

  function addLoadedClass() {
    setTimeout(function () {
      $(".loading-image")
        .removeClass("loading-image")
        .addClass("loaded-image");
    }, 1000);
  }
  $(window).on("load", function () {
    addLoadedClass();
  });
  document.addEventListener("shopify:section:load", function () {
    addLoadedClass();
  });

  document.addEventListener("shopify:section:select", function () {
    addLoadedClass();
  });

  document.addEventListener("shopify:block:select", function () {
    addLoadedClass();
  });

}

jQuery(function () {
  jQuery().on("click", function () {
    jQuery("iframe")
      .contents()
      .find("video")
      .each(function () {
        this.currentTime = 0;
        this.pause();
      });
  });
});


document.querySelector(".header-drawer__close").addEventListener("click", closeDrawerMenu);
function closeDrawerMenu() {
  document.querySelector("body").classList.remove("overflow-hidden-tablet");
}

$("#dT_TopStickySearchBtn").click(function (ev) {
  ev.preventDefault();
  $("#dT_top-sticky").addClass("search-show");
  $("#dT_top-sticky .search-modal").css("opacity", "1");
  $("body").addClass("search-overlay-open");
   $("#dT_top-sticky .search__input").focus();
});

$(".dT_TopStickySearchCloseBtn, .modal-overlay").click(function (ev) {
  ev.preventDefault();
  $("#dT_top-sticky").removeClass("search-show");
  $("#dT_top-sticky .search-modal").css("opacity", "0");
  $("body").removeClass("search-overlay-open");
});

function showSubMenu() {
  setTimeout(function () {
    $("#AccessibleNav .sub-menu-block").show();
  }, 1000);
}

$(window).on("load", function () {
  showSubMenu();
});

document.addEventListener("shopify:section:load", function () {
  showSubMenu();
});

document.addEventListener("shopify:section:select", function () {
  showSubMenu();
});

document.addEventListener("shopify:block:select", function () {
  showSubMenu();
});

$(document).ready(function () {
  setTimeout(function () {
 document.getElementById("MainContent").classList.remove("placeholder-shadow-blocks");
    }, 2000);
});

$(function() {
  $('.acc__title').click(function(j) {    
    var dropDown = $(this).closest('.dt-sc-tabs-content');
    $(this).closest('dt-sc-tabs-content').not(dropDown).slideUp();    
    if ($(this).hasClass('active')) {
      $(this).removeClass('active');
    } else {
      $(this).closest('dt-sc-tabs-content.active').removeClass('active');
      $(this).addClass('active');
    }    
    dropDown.stop(false, true).slideToggle();
    j.preventDefault();
  });
});


$(document).ready(function(){ 
    $('.tablinks').click(function(){  
      $(".dt-sc-tabs-content").removeClass('tab-active-content');
      $(".dt-sc-tabs-content[data-id='"+$(this).attr('data-id')+"']").addClass("tab-active-content");
      $(".tablinks").removeClass('active-tab');     
      $(this).addClass('active-tab');
     });
});

$(document).ready(function () {
  hotSpot();
});
$(window).on("resize", function () {
  hotSpot();
});
function hotSpot() {
    if($(window).width() > 767) 
    {     
       if($('.tool-tip-style-1').length > 0) {         
      jQuery(function($) {
       $('.dt-sc-hotspot-item').each(function () {
        var pop = $(this).find('.dt-sc-hotspot-popup');
        pop.click(function(e) {
          e.stopPropagation();
        });

        $(this).find('a.dt-sc-hotspot-marker').click(function(e) {
          e.preventDefault();
          e.stopPropagation();                
          $(this).parent().parent().addClass('this-hotspot-in-active');          
          // For icons disable 
          if ($(this).hasClass("clicked")) {
          $(this).removeClass("clicked");     
          $('.this-hotspot-in-active').find('a.dt-sc-hotspot-marker').css({'opacity':'0','pointer-events':'none'});;  
          $(this).css({'opacity':'1','pointer-events':'none'});   
          $('.dt-sc-hotspot-item').removeClass('open');          
          $('a.dt-sc-hotspot-marker').css({'opacity':'1','pointer-events':'none'}); 
          }
          else
          {
          $(this).addClass("clicked");               
          $('.this-hotspot-in-active').find('a.dt-sc-hotspot-marker').css({'opacity':'0','pointer-events':'none'});;  
          $(this).css({'opacity':'1','pointer-events':'auto'});     
          $(this).parent().addClass('open');          
          $(this).next('.dt-sc-hotspot-popup').toggleClass('dt-sc-popup-open');
          $(this).parent().siblings().children('.dt-sc-hotspot-popup').removeClass('dt-sc-popup-open');
            }
          // Disable End          
          
        });

        $(document).click(function() {
          $('.dt-sc-hotspot-wrapper').removeClass('this-hotspot-in-active');
          pop.removeClass('dt-sc-popup-open');
          $('.dt-sc-hotspot-item').removeClass('open');
          $('a.dt-sc-hotspot-marker').removeClass('clicked');
          $('a.dt-sc-hotspot-marker').css({'opacity':'1','pointer-events':'auto'}); 
        });              
      });
  });
       }
       if($('.tool-tip-style-3').length > 0) {           
      jQuery(function($) {
       $('.dt-sc-hotspot-item').each(function () {
        var pop = $(this).find('.dt-sc-hotspot-popup');
        pop.hover(function(e) {
          e.stopPropagation();
        });

        $(this).find('a.dt-sc-hotspot-marker').hover(function(e) {
          e.preventDefault();
          e.stopPropagation();                
          $(this).parent().parent().addClass('this-hotspot-in-active');
          // For icons disable 
          if ($(this).hasClass("clicked")) {
          $(this).removeClass("clicked");     
          $('.this-hotspot-in-active').find('a.dt-sc-hotspot-marker').css({'opacity':'0','pointer-events':'none'});;  
          $(this).css({'opacity':'1','pointer-events':'auto'});   
          $('.dt-sc-hotspot-item').removeClass('open');          
          $('a.dt-sc-hotspot-marker').css({'opacity':'1','pointer-events':'auto'}); 
          }
          else
          {
          $(this).addClass("clicked");               
          $('.this-hotspot-in-active').find('a.dt-sc-hotspot-marker').css({'opacity':'0','pointer-events':'none'});;  
          $(this).css({'opacity':'1','pointer-events':'auto'});     
          $(this).parent().addClass('open');          
          $(this).next('.dt-sc-hotspot-popup').toggleClass('dt-sc-popup-open');
          $(this).parent().siblings().children('.dt-sc-hotspot-popup').removeClass('dt-sc-popup-open');
            }
          // Disable End          
        });
        $(this).find('a.dt-sc-hotspot-marker').mouseout(function(e) {
         $('.dt-sc-hotspot-wrapper').removeClass('this-hotspot-in-active');
          pop.removeClass('dt-sc-popup-open');
          $('.dt-sc-hotspot-item').removeClass('open');
          $('a.dt-sc-hotspot-marker').removeClass('clicked');
          $('a.dt-sc-hotspot-marker').css({'opacity':'1','pointer-events':'auto'});
        });
         
        $(document).click(function() {
          $('.dt-sc-hotspot-wrapper').removeClass('this-hotspot-in-active');
          pop.removeClass('dt-sc-popup-open');
          $('.dt-sc-hotspot-item').removeClass('open');
          $('a.dt-sc-hotspot-marker').removeClass('clicked');
          $('a.dt-sc-hotspot-marker').css({'opacity':'1','pointer-events':'auto'}); 
        });              
      });
  });
       }
    }  

   if($(window).width() < 768) {     
      $('.dt-sc-hotspot-popup').addClass('mfp-hide');
      $('.dt-sc-hotspot-marker').each(function() {
        $(this).magnificPopup({       
        type: 'inline',
        closeOnBgClick: true,
        closeBtnInside: false,
        showCloseBtn: true
        });
      });        
    }    
}

function isValidDDMMYYYY(dateString) {
    // Check if format is dd-mm-yyyy (strictly)
    var pattern = /^(\d{2})-(\d{2})-(\d{4})$/;
    if (!pattern.test(dateString)) {
        return false;
    }
    
    var parts = dateString.split('-');
    var day = parseInt(parts[0], 10);
    var month = parseInt(parts[1], 10);
    var year = parseInt(parts[2], 10);
    
    // Check if month is between 1-12
    if (month < 1 || month > 12) {
        return false;
    }
    
    // Check if day is valid for the month
    var daysInMonth = new Date(year, month, 0).getDate();
    if (day < 1 || day > daysInMonth) {
        return false;
    }
    
    // Additional check to reject yyyy-mm-dd format
    // If first part is > 31 and < 1000, it's likely a year, reject it
    var firstPart = parseInt(parts[0], 10);
    var lastPart = parseInt(parts[2], 10);
    
    // Reject if first part looks like a year (between 1000-9999 and > 31)
    if (firstPart >= 1000 && firstPart <= 9999 && firstPart > 31) {
        return false;
    }
    
    // Reject if last part looks like a day (less than 32 and year is not valid)
    if (lastPart >= 1 && lastPart <= 31 && (year < 1000 || year > 9999)) {
        return false;
    }
    
    return true;
}

function makeTimer() {

  $('.product-deal-count').each(function() {
   
    var endTime = new Date($(this).attr('data-end-time'));		
    endTime = (Date.parse(endTime) / 1000);

    var now = new Date();
    now = (Date.parse(now) / 1000);

    var timeLeft = endTime - now;
    
    if(timeLeft > 0) {
      var days = Math.floor(timeLeft / 86400); 
      var hours = Math.floor((timeLeft - (days * 86400)) / 3600);
      var minutes = Math.floor((timeLeft - (days * 86400) - (hours * 3600 )) / 60);
      var seconds = Math.floor((timeLeft - (days * 86400) - (hours * 3600) - (minutes * 60)));

      if (hours < "10") { hours = "0" + hours; }
      if (minutes < "10") { minutes = "0" + minutes; }
      if (seconds < "10") { seconds = "0" + seconds; }
      $(this).find(".days").html(days + "<span>"+window.deals.days+"</span>");
      $(this).find(".hours").html(hours + "<span>"+window.deals.hours+"</span>");
      $(this).find(".minutes").html(minutes + "<span>"+window.deals.minutes+"</span>");
      $(this).find(".seconds").html(seconds + "<span>"+window.deals.seconds+"</span>");
      
    } else {
      $(this).find(".deal-lable").hide();
      $(this).find(".deal-clock").hide();
    }
    
  });

}

setInterval(function() { makeTimer(); }, 1000);

function makeTimer1() {

  $('.deal-count-section').each(function() {

    var dateAttr = $(this).attr('data-end-time');
    
    var ddmmyyyyPattern = /^(0[1-9]|[12][0-9]|3[01])-(0[1-9]|1[0-2])-([12][0-9]{3})$/;
    
    var yyyymmddPattern = /^([12][0-9]{3})-(0[1-9]|1[0-2])-(0[1-9]|[12][0-9]|3[01])$/;
    
    if (yyyymmddPattern.test(dateAttr)) {
      $(this).find(".deal-lable").hide();
      $(this).find(".deal-clock").hide();
      return; 
    }
    
    if (!ddmmyyyyPattern.test(dateAttr)) {
      $(this).find(".deal-lable").hide();
      $(this).find(".deal-clock").hide();
      return;
    }
    
    var dateParts = dateAttr.split('-');
    var day = parseInt(dateParts[0], 10);
    var month = parseInt(dateParts[1], 10);
    var year = parseInt(dateParts[2], 10);
    
    // Additional validation to ensure day is valid for the month
    var testDate = new Date(year, month - 1, day);
    if (testDate.getDate() !== day || testDate.getMonth() !== month - 1 || testDate.getFullYear() !== year) {
      console.error('REJECTED: Invalid date. Received: ' + dateAttr);
      $(this).find(".deal-lable").hide();
      $(this).find(".deal-clock").hide();
      return;
    }
    
    var endTime = testDate.getTime() / 1000;
    var now = new Date();
    now = (Date.parse(now) / 1000);

    var timeLeft = endTime - now;

    if(timeLeft > 0) {
      var days = Math.floor(timeLeft / 86400); 
      var hours = Math.floor((timeLeft - (days * 86400)) / 3600);
      var minutes = Math.floor((timeLeft - (days * 86400) - (hours * 3600)) / 60);
      var seconds = Math.floor((timeLeft - (days * 86400) - (hours * 3600) - (minutes * 60)));

      if (hours < "10") { hours = "0" + hours; }
      if (minutes < "10") { minutes = "0" + minutes; }
      if (seconds < "10") { seconds = "0" + seconds; }
      
      var isInsideMainProduct = $(this).closest('.main-product, .featured-product, .single-product, .product-main, .featured-product-section').length > 0;
      
      var isInsideMainProductAlt = $(this).parents().hasClass('main-product') || 
                                    $(this).parents().hasClass('featured-product') ||
                                    $(this).closest('.product-item').hasClass('main') ||
                                    $(this).closest('.product').hasClass('featured');
      
      if(isInsideMainProduct || isInsideMainProductAlt) {
        $(this).find(".days").html(days + "<span>" + window.deals.days + "</span>");
        $(this).find(".hours").html(hours + "<span>" + window.deals.hours + "</span>");
        $(this).find(".minutes").html(minutes + "<span>" + window.deals.minutes + "</span>");
        $(this).find(".seconds").html(seconds + "<span>" + window.deals.seconds + "</span>");
      } else {

        $(this).find(".days").html(days);
        $(this).find(".hours").html(hours);
        $(this).find(".minutes").html(minutes);
        $(this).find(".seconds").html(seconds);
      }

    } else {
      $(this).find(".deal-lable").hide();
      $(this).find(".deal-clock").hide();
    }

  });

}
setInterval(function() { makeTimer1(); }, 1000);
class ProductTabsCarousel extends HTMLElement {
  constructor() {
    super();
    this.tabButtons = this.querySelectorAll('[data-tab]');
    this.tabContents = this.querySelectorAll('[data-tab-content]');
    this.swipers = [];
    this.setupTabs();
    this.initSwipers();
    this.setupResizeObserver();
  }

  setupTabs() {
    this.tabButtons.forEach(button => {
      button.addEventListener('click', () => {
        const tabId = button.getAttribute('data-tab');

        this.tabButtons.forEach(btn => btn.classList.remove('active'));
        this.tabContents.forEach(content => content.classList.remove('active'));

        button.classList.add('active');
        const activeContent = this.querySelector(`[data-tab-content="${tabId}"]`);
        if (activeContent) activeContent.classList.add('active');

        const activeTabIndex = Array.from(this.tabButtons).indexOf(button);
        if (this.swipers[activeTabIndex]) {
          this.swipers[activeTabIndex].update();
        }
      });
    });

    if (this.tabButtons.length > 0) {
      this.tabButtons[0].click();
    }
  }

  initSwipers() {
    this.tabContents.forEach((content, index) => {
      const swiperEl = content.querySelector('.swiper');
      const prevEl = content.querySelector('.swiper-button-prev');
      const nextEl = content.querySelector('.swiper-button-next');
      const paginationEl = content.querySelector('.swiper-pagination');
      const sliderConfigElement = content.querySelector('[data-swiper-slider]');
      const sliderOptionsData = sliderConfigElement.getAttribute("data-slider-options");      
        if (!sliderOptionsData) return;
        const sliderOptions = $.extend(true, {
            effect: "slide",
            direction: "horizontal",
            autoplay: true,
            autoplaySpeed: 5,
            spaceBetween: 0, 
            additionalOptions: {}
        }, JSON.parse(sliderOptionsData));
       
        const numericPattern = /^\d+$/;
        Object.keys(sliderOptions).forEach((key) => {        
            if (typeof sliderOptions[key] === "string" && numericPattern.test(sliderOptions[key])) {
                sliderOptions[key] = parseInt(sliderOptions[key], 10);
            }
        });
      
      
      if (swiperEl) {
        const swiper = new Swiper(swiperEl, {
          slidesPerView: 2,
          spaceBetween: 16,
          navigation: {
            nextEl,
            prevEl,
          },
          pagination: {
            el: paginationEl,
            clickable: true,
          },
          breakpoints: {
                320: {
                    slidesPerView: sliderOptions.mobile || 1,
                    spaceBetween: 10
                },
                577: {
                    slidesPerView: sliderOptions.tablet || 2,
                    spaceBetween: sliderOptions.space * 0.5
                },
                768: {
                    slidesPerView: sliderOptions.tablet || 2,
                    spaceBetween: sliderOptions.space * 0.5
                },
                992: {
                    slidesPerView: sliderOptions.laptop || 3,
                    spaceBetween: sliderOptions.space * 0.7
                },
                1440: {
                    slidesPerView: sliderOptions.desktop || 4
                }
             }
        });
        this.swipers.push(swiper);
      }
    });
  }

  setupResizeObserver() {
    const resizeObserver = new ResizeObserver(() => {
      this.swipers.forEach(swiper => {
        if (swiper) swiper.update();
      });
    });

    resizeObserver.observe(this);
  }

  disconnectedCallback() {
    this.swipers.forEach(swiper => swiper?.destroy());
  }
}

customElements.define('product-tabs-carousel', ProductTabsCarousel);

// document.addEventListener("click", () => {
//   const isOpen = document.querySelector('.mobile-facets__open-wrapper[aria-expanded="true"]');
//   const header = document.querySelector('.shopify-section-header-sticky');

//   if (!header) return;

//   if (isOpen) {
//     header.style.opacity = "0";
//     header.style.visibility = "visible";
//   } 
// });


// New Script

// ANNOUNCEMENT BAR

if (!customElements.get('vertical-bar')) {
  customElements.define('vertical-bar', class VerticalBar extends HTMLElement {
    constructor() {
      super();

      this.container = this.querySelector(".vertical-marquee-selector");
      if (!this.container) return;

      let timer = parseInt(this.container.getAttribute('data-timer'), 10) || 0;
      timer = timer * 1000;

      const autoplayConfig = timer > 0
        ? {
            delay: timer,
            disableOnInteraction: false,
          }
        : false;

      const swiper = new Swiper(this.container, {
        loop: true,
        effect: 'fade',

        autoplay: autoplayConfig, 

        navigation: {
          nextEl: ".swiper-next",
          prevEl: ".swiper-prev",
        }
      });
    }
  });
}

// SLIDESHOW

let openOffcanvasCount = 0;
if (!customElements.get('wdt-slideshow')) {
  customElements.define('wdt-slideshow', class WDT_slideShow  extends HTMLElement {
    constructor() {
        super();
        this.slider = this.querySelector("[data-swiper-slider]");
    }

    connectedCallback() {
        this.init();
    }

    init() {
        if (!this.slider) {            
            return;
        }

        const slideItems = this.slider.querySelectorAll(".slide-item");
        if (slideItems.length <= 1) {
           // return;
        }

        const sliderOptions = this.slider.getAttribute("data-slider-options");

        if (!sliderOptions) {
            return;
        }

        try {
            const options = JSON.parse(sliderOptions);

            Object.keys(options).forEach(key => {
                if (typeof options[key] === "string" && /^\d+$/.test(options[key])) {
                    options[key] = parseInt(options[key], 10);
                }
            });

            

            const autoplay = options.auto_play > 0 ? options.auto_play * 1000 : false;
            const loop = options.loop === "true" || options.loop === true;           
            const fade = options.fade === "true" || options.fade === true;
            const centeredSlides = options.mode === "true" || options.mode === true;
            const slidePerview = options.slidePerview > 0 ? options.slidePerview : 1;

            const swiperOptions = {
               
                loop: loop,
                autoplay: autoplay ? { delay: autoplay, disableOnInteraction: false,  pauseOnMouseEnter: true } : false,
                effect: fade ? 'fade' : 'slide',
                centeredSlides: centeredSlides,
                speed: 2000,
                 spaceBetween: 24,
                  pagination: {
                  el: this.querySelector(".swiper-pagination"),
                 clickable: true
            },
                navigation: {
                    nextEl: this.querySelector(".swiper-button-next"),
                    prevEl: this.querySelector(".swiper-button-prev")
                },
                lazy: {
                    loadOnTransitionStart: true,
                    loadPrevNext: true
                },
                breakpoints: {
                575: {
                slidesPerView: slidePerview || 1
                }
              },
                ...options.options
            };
            this.swiperInstance = new Swiper(this.slider, swiperOptions);
              window.addEventListener('resize', () => {
                if (this.swiperInstance.params.loop) {
                    this.swiperInstance.loopDestroy();
                    this.swiperInstance.loopCreate();
                }

                this.swiperInstance.update();
            });

        } catch (error) {
        }
    }
});
}

// SWIPERSLIDE

if (!customElements.get('wdt-swiper-slider')) {
  customElements.define('wdt-swiper-slider', class WDT_Swiper extends HTMLElement{
    constructor() {
        super();     
        this.sliderConfigElement = this.querySelector("[data-slider-options]");         
        if (this.sliderConfigElement) this.initializeSlider();
    }

    initializeSlider() {       
        const sliderOptionsData = this.sliderConfigElement.getAttribute("data-slider-options");      
        if (!sliderOptionsData) return;
        const sliderOptions = $.extend(true, {
            effect: "slide",
            direction: "horizontal",
            autoplay: true,
            autoplaySpeed: 5,
            spaceBetween: 0, 
            additionalOptions: {}
        }, JSON.parse(sliderOptionsData));
       
        const numericPattern = /^\d+$/;
        Object.keys(sliderOptions).forEach((key) => {        
            if (typeof sliderOptions[key] === "string" && numericPattern.test(sliderOptions[key])) {
                sliderOptions[key] = parseInt(sliderOptions[key], 10);
            }
        });

       
        const autoplaySettings = sliderOptions.auto_play > 0 ? { delay: 1000 * sliderOptions.auto_play } : false;     
        const loopEnabled = sliderOptions.loop === "true" || sliderOptions.loop === true;     
        const centeredSlides = sliderOptions.mode === "true" || sliderOptions.mode === true;

        const swiperOptions = $.extend(true, {
            init: false,
            spaceBetween: sliderOptions.space,
            loop: loopEnabled,
            preventClicks: true,
            preventClicksPropagation: true,
            autoplay: autoplaySettings,
            centeredSlides: centeredSlides,
            speed: 2000, 
            navigation: {
                nextEl: this.sliderConfigElement.querySelector(".swiper-button-next"),
                prevEl: this.sliderConfigElement.querySelector(".swiper-button-prev")
            },
            pagination: {
                el: this.sliderConfigElement.querySelector(".swiper-pagination"),
                clickable: true
            },
            lazy: true,
            focusableElements: 'input, select, option, textarea, video, label',
            breakpoints: {
                320: {
                    slidesPerView: sliderOptions.mobile || 1,
                    spaceBetween: sliderOptions.space * 0.5
                },
                576: {
                    slidesPerView: sliderOptions.tablet || 2,
                    spaceBetween: sliderOptions.space * 0.7
                },
                992: {
                    slidesPerView: sliderOptions.laptop || 3,
                    spaceBetween: sliderOptions.space * 0.8
                },
                1440: {
                    slidesPerView: sliderOptions.desktop || 4
                }
            }
        }, sliderOptions.additionalOptions);


        const swiperContainer = this.sliderConfigElement.querySelector("[data-swiper-slider]");
        const swiperInstance = new Swiper(swiperContainer, swiperOptions);
        swiperInstance.on("init", () => {
            swiperInstance.update();
        });

        swiperInstance.init();
    }
});
}

document.querySelectorAll('.variant-swatch.item-swatch.color-values').forEach((li, index) => {
  const parentContainer = li.closest('.variant-option-color');
  if (parentContainer && index === 0) {
    const firstItem = parentContainer.querySelector('.variant-swatch.item-swatch.color-values');
    if (firstItem) firstItem.classList.add('active');
  }

  const handleInteraction = () => {
    const container = li.closest('.variant-option-color');
    if (container) {
      container.querySelectorAll('.variant-swatch.item-swatch.color-values').forEach(item => {
        item.classList.remove('active');
      });
    }

    li.classList.add('active');
    const variantPrice = li.getAttribute('data-variant-price');

    if (!variantPrice) return;
    const productCard = li.closest('.card_body');

    if (!productCard) return;

    const priceElement = productCard.querySelector('.price-block > div');

    if (!priceElement) return;

    priceElement.style.transition = 'opacity 0.15s ease';
    priceElement.style.opacity = '0.5';

    setTimeout(() => {
      priceElement.textContent = variantPrice;
      priceElement.style.opacity = '1';
    }, 120);
  };
  
  li.addEventListener('click', handleInteraction);
});

document.addEventListener('click', function (e) {

  const swatch = e.target.closest('.item-swatch');
  if (!swatch) return;

  const card = swatch.closest('.resource-card');
  if (!card) {
    console.log('card not found');
    return;
  }

  const mainImage = card.querySelector('.media_primary_image');
  const secondaryImage = card.querySelector('.media_secondary_image');

  const imageEl = swatch.querySelector('[data-image]');
  const newImage = imageEl ? imageEl.getAttribute('data-image') : null;

  if (!newImage) {
    console.log('No data-image found');
    return;
  }

  console.log('Switching image:', newImage);

  const url = newImage.startsWith('//') ? 'https:' + newImage : newImage;
  if (mainImage) mainImage.src = url;
  if (mainImage) mainImage.srcset = url;

 
const swatchItem = swatch.closest('.variant-swatch');
if (!swatchItem) return;


card.querySelectorAll('.variant-swatch').forEach(item => {
  item.classList.remove('active');
});


swatchItem.classList.add('active');

});

document.addEventListener('click', function (e) {
  const playIcon = e.target.closest('.playicon_video');
  if (!playIcon) return;
  
  const container = playIcon.closest('[id^="video-container-"]');
  if (!container) return;

  const coverImage = container.querySelector('.cover_image');

  const iframe = container.querySelector('iframe');

  if (iframe) {
    let src = iframe.getAttribute('src');
    
    src = src.replace(/[?&]autoplay=1/, '');
    src = src.replace(/[?&]autoplay=0/, '');
    src += (src.includes('?') ? '&' : '?') + 'autoplay=1';
    
    if (src.includes('youtube.com') || src.includes('youtu.be')) {
      src += '&enablejsapi=1';
    }
    
    iframe.setAttribute('src', src);
  }

  const video = container.querySelector('video');
  
  if (video) {
    video.muted = false;
    video.play().catch(error => {
      console.error('Video playback failed:', error);

      video.muted = true;
      video.play().catch(e => console.log('Still cannot play:', e));
    });
  }

  if (playIcon) playIcon.style.setProperty('display', 'none', 'important');
  if (coverImage) coverImage.style.setProperty('display', 'none', 'important');
  });


$(document).on('change', 'select[name^="options"]', function () {
  const value = $(this).val();

  const label = $(this)
    .closest('.product-form__input, .product, form')
    .find('.form__label');

  label.next('span').text(value);
});

// COLLECTION

if (!customElements.get('wdt-collection-sidebar')) {
  customElements.define('wdt-collection-sidebar', class WDT_Swiper extends HTMLElement{
    constructor() {
        super();     
        this.sliderConfigElement = this.querySelector("[data-slider-options]");         
        if (this.sliderConfigElement) this.initializeSlider();
    }

    initializeSlider() {       
        const sliderOptionsData = this.sliderConfigElement.getAttribute("data-slider-options");      
        if (!sliderOptionsData) return;
        const sliderOptions = $.extend(true, {
            effect: "slide",
            direction: "horizontal",
            autoplay: true,
            autoplaySpeed: 5,
            spaceBetween: 0, 
            additionalOptions: {}
        }, JSON.parse(sliderOptionsData));
       
        const numericPattern = /^\d+$/;
        Object.keys(sliderOptions).forEach((key) => {        
            if (typeof sliderOptions[key] === "string" && numericPattern.test(sliderOptions[key])) {
                sliderOptions[key] = parseInt(sliderOptions[key], 10);
            }
        });

       
        const autoplaySettings = sliderOptions.auto_play > 0 ? { delay: 1000 * sliderOptions.auto_play } : false;     
        const loopEnabled = sliderOptions.loop === "true" || sliderOptions.loop === true;     
        const centeredSlides = sliderOptions.mode === "true" || sliderOptions.mode === true;

        const swiperOptions = $.extend(true, {
            init: false,
            spaceBetween: sliderOptions.space,
            loop: loopEnabled,
            preventClicks: true,
            preventClicksPropagation: true,
            autoplay: autoplaySettings,
            centeredSlides: centeredSlides,
            speed: 2000, 
            navigation: {
                nextEl: this.sliderConfigElement.querySelector("#swiper-sidebar-next"),
                prevEl: this.sliderConfigElement.querySelector("#swiper-sidebar-prev")
            },
            pagination: {
                el: this.sliderConfigElement.querySelector(".swiper-pagination"),
                clickable: true
            },
            lazy: true,
            focusableElements: 'input, select, option, textarea, video, label',
            breakpoints: {
                320: {
                    slidesPerView: sliderOptions.mobile || 1,
                    spaceBetween: sliderOptions.space * 0.5
                },
                576: {
                    slidesPerView: sliderOptions.tablet || 2,
                    spaceBetween: sliderOptions.space * 0.7
                },
                992: {
                    slidesPerView: sliderOptions.laptop || 3,
                    spaceBetween: sliderOptions.space * 0.8
                },
                1200: {
                    slidesPerView: sliderOptions.desktop || 4
                }
            }
        }, sliderOptions.additionalOptions);


        const swiperContainer = this.sliderConfigElement.querySelector("[data-swiper-slider]");
        const swiperInstance = new Swiper(swiperContainer, swiperOptions);
        swiperInstance.on("init", () => {
            swiperInstance.update();
        });

        swiperInstance.init();
    }
});
}

const drawer = document.querySelector('#Details-menu-drawer-container');

document.addEventListener('DOMContentLoaded', () => {
  const drawer = document.querySelector('#Details-menu-drawer-container');
  const announcementBar = document.querySelector('#shopify-section-announcement-bar');

  if (!drawer) return;

  function handleDrawerState() {
    if (drawer.hasAttribute('open')) {
      const scrollBarWidth = window.innerWidth - document.documentElement.clientWidth;
      document.body.style.overflow = 'hidden';
      document.body.style.paddingRight = scrollBarWidth + 'px';
      if (announcementBar) {
        announcementBar.style.position = 'relative';
        announcementBar.style.zIndex = '0';
      }

    } else {
      document.body.style.overflow = '';
      document.body.style.paddingRight = '';
      if (announcementBar) {
        announcementBar.style.zIndex = '';
        announcementBar.style.position = '';
      }
    }
  }

  drawer.addEventListener('toggle', handleDrawerState);
  handleDrawerState();
});



document.addEventListener('DOMContentLoaded', function () {
  const swatchGrid = document.getElementById('compareColorsGrid');
  const imageGrid = document.getElementById('compareColorsGridwithimage');

  if (!swatchGrid || !imageGrid) return;

  let activeSwatches = new Set();
  function getSelectedSize() {
    const selected = document.querySelector(
      '.variant-option-item.selected[data-option-value="Size"]'
    );
    return selected ? selected.dataset.value : '';
  }

  function updateVariantLabel(targetCol) {
    const card = targetCol.querySelector('.compare-color-card');
    const labelEl = targetCol.querySelector('.variant-label');

    if (!card || !labelEl) return;

    const colorName = card.dataset.colorName;
    const sizeValue = getSelectedSize();

    labelEl.textContent = sizeValue
      ? `${colorName} / ${sizeValue}`
      : colorName;
  }

  function toggleSwatch(swatch, colorName) {
    const targetCol = imageGrid
      .querySelector(`[data-color-name="${colorName}"]`)
      ?.closest('.col-xl-3');

    if (!targetCol) return;

    if (swatch.classList.contains('active-swatch')) {
      swatch.classList.remove('active-swatch');
      targetCol.classList.add('d-none');
      activeSwatches.delete(colorName);
    } else {
      swatch.classList.add('active-swatch');
      targetCol.classList.remove('d-none');
      activeSwatches.add(colorName);

      updateVariantLabel(targetCol);
    }
  }


  const swatches = swatchGrid.querySelectorAll(
    '.swatch .compare-color-card'
  );

  if (swatches.length > 0) {
    const firstSwatch = swatches[0];
    const firstColor = firstSwatch.dataset.colorName;

    firstSwatch.classList.add('active-swatch');
    activeSwatches.add(firstColor);

    const firstTarget = imageGrid
      .querySelector(`[data-color-name="${firstColor}"]`)
      ?.closest('.col-xl-3');

    if (firstTarget) {
      firstTarget.classList.remove('d-none');
      updateVariantLabel(firstTarget);
    }
  }


  swatches.forEach((swatch) => {
    swatch.addEventListener('click', function (e) {
      e.preventDefault();
      toggleSwatch(this, this.dataset.colorName);
    });
  });


  document.addEventListener('click', function (e) {
    const sizeItem = e.target.closest(
      '.variant-option-item[data-option-value="Size"]'
    );
    if (!sizeItem) return;

    document
      .querySelectorAll('#compareColorsGridwithimage .col-xl-3:not(.d-none)')
      .forEach((col) => {
        updateVariantLabel(col);
      });
  });
});

function email__button() {
  document.querySelectorAll(".email_input_group").forEach((section) => {
    const btn = section.querySelector(".email__button");
    if (!btn) return;

    section.style.setProperty("--email-btn-width", btn.offsetWidth + "px");
  });
}

window.addEventListener("load", email__button);
window.addEventListener("resize", email__button);
document.addEventListener("shopify:section:load", email__button);



//Testimonial

if (!customElements.get('testimonial-slider')) {
  customElements.define('testimonial-slider', class WDT_Swiper extends HTMLElement{
    constructor() {
        super();     
        this.sliderConfigElement = this.querySelector("[data-slider-options]");         
        if (this.sliderConfigElement) this.initializeSlider();
    }

    initializeSlider() {       
        const sliderOptionsData = this.sliderConfigElement.getAttribute("data-slider-options");      
        if (!sliderOptionsData) return;
        const sliderOptions = $.extend(true, {
            effect: "slide",
            direction: "horizontal",
            autoplay: true,
            autoplaySpeed: 5,
            spaceBetween: 0, 
            additionalOptions: {}
        }, JSON.parse(sliderOptionsData));
       
        const numericPattern = /^\d+$/;
        Object.keys(sliderOptions).forEach((key) => {        
            if (typeof sliderOptions[key] === "string" && numericPattern.test(sliderOptions[key])) {
                sliderOptions[key] = parseInt(sliderOptions[key], 10);
            }
        });

       
        const autoplaySettings = sliderOptions.auto_play > 0 ? { delay: 1000 * sliderOptions.auto_play } : false;     
        const loopEnabled = sliderOptions.loop === "true" || sliderOptions.loop === true;     
        const centeredSlides = sliderOptions.mode === "true" || sliderOptions.mode === true;

        const swiperOptions = $.extend(true, {
            init: false,
            spaceBetween: sliderOptions.space,
            loop: loopEnabled,
            preventClicks: true,
            preventClicksPropagation: true,
            autoplay: autoplaySettings,
            centeredSlides: centeredSlides,
            speed: 2000, 
            navigation: {
                nextEl: this.sliderConfigElement.querySelector(".swiper-button-next"),
                prevEl: this.sliderConfigElement.querySelector(".swiper-button-prev")
            },
            pagination: {
                el: this.sliderConfigElement.querySelector(".swiper-pagination"),
                clickable: true
            },
            lazy: true,
            focusableElements: 'input, select, option, textarea, video, label',
            breakpoints: {
                320: {
                    slidesPerView: sliderOptions.mobile || 1,
                    spaceBetween: sliderOptions.space * 0.5
                },
                576: {
                    slidesPerView: sliderOptions.tablet || 1,
                    spaceBetween: sliderOptions.space * 0.7
                },
                992: {
                    slidesPerView: sliderOptions.laptop || 2,
                    spaceBetween: sliderOptions.space * 0.8
                },
                1540: {
                    slidesPerView: sliderOptions.desktop || 3
                }
            }
        }, sliderOptions.additionalOptions);


        const swiperContainer = this.sliderConfigElement.querySelector("[data-swiper-slider]");
        const swiperInstance = new Swiper(swiperContainer, swiperOptions);
        swiperInstance.on("init", () => {
            swiperInstance.update();
        });

        swiperInstance.init();
    }
});
}

/* custom carousel */

if (!customElements.get('custom-carousel-section')) {
  customElements.define('custom-carousel-section', class WDT_Swiper extends HTMLElement{
    constructor() {
        super();     
        this.sliderConfigElement = this.querySelector("[data-slider-options]");         
        if (this.sliderConfigElement) this.initializeSlider();
    }

    initializeSlider() {       
        const sliderOptionsData = this.sliderConfigElement.getAttribute("data-slider-options");      
        if (!sliderOptionsData) return;
        const sliderOptions = $.extend(true, {
            effect: "slide",
            direction: "horizontal",
            autoplay: true,
            autoplaySpeed: 5,
            spaceBetween: 0, 
            additionalOptions: {}
        }, JSON.parse(sliderOptionsData));
       
        const numericPattern = /^\d+$/;
        Object.keys(sliderOptions).forEach((key) => {        
            if (typeof sliderOptions[key] === "string" && numericPattern.test(sliderOptions[key])) {
                sliderOptions[key] = parseInt(sliderOptions[key], 10);
            }
        });

       
        const autoplaySettings = sliderOptions.auto_play > 0 ? { delay: 1000 * sliderOptions.auto_play } : false;     
        const loopEnabled = sliderOptions.loop === "true" || sliderOptions.loop === true;     
        const centeredSlides = sliderOptions.mode === "true" || sliderOptions.mode === true;

        const swiperOptions = $.extend(true, {
            init: false,
            spaceBetween: sliderOptions.space,
            loop: loopEnabled,
            preventClicks: true,
            preventClicksPropagation: true,
            autoplay: autoplaySettings,
            centeredSlides: centeredSlides,
            speed: 2000, 
            navigation: {
                nextEl: this.sliderConfigElement.querySelector(".swiper-button-next"),
                prevEl: this.sliderConfigElement.querySelector(".swiper-button-prev")
            },
            pagination: {
                el: this.sliderConfigElement.querySelector(".swiper-pagination"),
                clickable: true
            },
            lazy: true,
            focusableElements: 'input, select, option, textarea, video, label',
            breakpoints: {
                320: {
                    slidesPerView: sliderOptions.mobile || 1,
                    spaceBetween: sliderOptions.space 
                },
                576: {
                    slidesPerView: sliderOptions.tablet || 2,
                    spaceBetween: sliderOptions.space 
                },
                992: {
                    slidesPerView: sliderOptions.laptop || 3,
                    spaceBetween: sliderOptions.space
                },
                1400: {
                    slidesPerView: sliderOptions.desktop || 4
                }               
            }
        }, sliderOptions.additionalOptions);


        const swiperContainer = this.sliderConfigElement.querySelector("[data-swiper-slider]");
        const swiperInstance = new Swiper(swiperContainer, swiperOptions);
        swiperInstance.on("init", () => {
            swiperInstance.update();
        });

        swiperInstance.init();
    }
});
}

//collection-banner-slider

if (!customElements.get('wdt-collection-banner-slider')) {
  customElements.define('wdt-collection-banner-slider', class WDT_Swiper extends HTMLElement{
    constructor() {
        super();     
        this.sliderConfigElement = this.querySelector("[data-slider-options]");         
        if (this.sliderConfigElement) this.initializeSlider();
    }

    initializeSlider() {       
        const sliderOptionsData = this.sliderConfigElement.getAttribute("data-slider-options");      
        if (!sliderOptionsData) return;
        const sliderOptions = $.extend(true, {
            effect: "slide",
            direction: "horizontal",
            autoplay: true,
            autoplaySpeed: 5,
            spaceBetween: 0, 
            additionalOptions: {}
        }, JSON.parse(sliderOptionsData));
       
        const numericPattern = /^\d+$/;
        Object.keys(sliderOptions).forEach((key) => {        
            if (typeof sliderOptions[key] === "string" && numericPattern.test(sliderOptions[key])) {
                sliderOptions[key] = parseInt(sliderOptions[key], 10);
            }
        });

       
        const autoplaySettings = sliderOptions.auto_play > 0 ? { delay: 1000 * sliderOptions.auto_play } : false;     
        const loopEnabled = sliderOptions.loop === "true" || sliderOptions.loop === true;     
        const centeredSlides = sliderOptions.mode === "true" || sliderOptions.mode === true;

        const swiperOptions = $.extend(true, {
            init: false,
            spaceBetween: sliderOptions.space,
            loop: loopEnabled,
            preventClicks: true,
            preventClicksPropagation: true,
            autoplay: autoplaySettings,
            centeredSlides: centeredSlides,
            speed: 2000, 
            navigation: {
                nextEl: this.sliderConfigElement.querySelector(".swiper-button-next"),
                prevEl: this.sliderConfigElement.querySelector(".swiper-button-prev")
            },
            pagination: {
                el: this.sliderConfigElement.querySelector(".swiper-pagination"),
                clickable: true
            },
            lazy: true,
            focusableElements: 'input, select, option, textarea, video, label',
            breakpoints: {
                320: {
                    slidesPerView: sliderOptions.mobile || 1,
                    spaceBetween: sliderOptions.space * 0.5
                },
                576: {
                    slidesPerView: sliderOptions.tablet || 2,
                    spaceBetween: sliderOptions.space * 0.7
                },
                992: {
                    slidesPerView: sliderOptions.laptop || 3,
                    spaceBetween: sliderOptions.space * 0.8
                },
                1400: {
                    slidesPerView: sliderOptions.desktop || 4
                }
            }
        }, sliderOptions.additionalOptions);


        const swiperContainer = this.sliderConfigElement.querySelector("[data-swiper-slider]");
        const swiperInstance = new Swiper(swiperContainer, swiperOptions);
        swiperInstance.on("init", () => {
            swiperInstance.update();
        });

        swiperInstance.init();
    }
});
}

if (!customElements.get('gallery-component')) {
  customElements.define('gallery-component', class GalleryComponent extends HTMLElement {
    constructor() {
      super();
      this.imageBlocks = [];
      this.contentBlocks = [];
    }
    connectedCallback() {
      this.imageBlocks = this.querySelectorAll(".media-gallery .media-image");
      this.contentBlocks = this.querySelectorAll(".gallery-content .content-item");
      this.initialize();
    }
    initialize() {
      if (this.imageBlocks.length > 0 && this.contentBlocks.length > 0) {
        // Set the first block as active initially
        this.setActiveBlock(0);
      }
      this.contentBlocks.forEach((contentBlock, index) => {
        contentBlock.addEventListener("mouseover", () => {
          this.setActiveBlock(index);
        });
      });
    }
    setActiveBlock(index) {
      // Remove 'highlight' class from all blocks
      this.imageBlocks.forEach((block) => block.classList.remove("highlight"));
      this.contentBlocks.forEach((block) => block.classList.remove("highlight"));
      // Add 'highlight' class to the active block
      if (this.imageBlocks[index] && this.contentBlocks[index]) {
        this.imageBlocks[index].classList.add("highlight");
        this.contentBlocks[index].classList.add("highlight");
      }
    }
  });
}

const menuButton = document.querySelector(
  '#Details-menu-drawer-container summary'
);

menuButton.addEventListener('click', () => {
  const drawer = document.querySelector('#menu-drawer');

  drawer.style.transition = 'none';
  drawer.offsetHeight;
  drawer.style.transition = '';
});

window.addEventListener('resize', () => {
  const menuButton = document.querySelector(
    '#Details-menu-drawer-container summary'
  );

  if (
    window.innerWidth > 990 &&
    menuButton.getAttribute('aria-expanded') === 'true'
  ) {
    menuButton.click();
  }
});

document.addEventListener('DOMContentLoaded', () => {

  const menuDrawer = document.querySelector('.menu-drawer');

  if (!menuDrawer) return;

  // Parent menu accordion
  const topLevelMenus = menuDrawer.querySelectorAll('.top-level-link > details');

  topLevelMenus.forEach((menu) => {
    menu.addEventListener('toggle', function () {
      if (!this.open) return;

      topLevelMenus.forEach((other) => {
  if (other !== this && other.open) {
    const content = other.querySelector('summary').nextElementSibling;

    if (content) {
      content.style.height = content.scrollHeight + 'px';

      requestAnimationFrame(() => {
        content.style.height = '0px';
      });

      content.addEventListener(
        'transitionend',
        () => {
          other.removeAttribute('open');
        },
        { once: true }
      );
    }
  }
});
    });
  });

  // Child menu accordion
  const childMenus = menuDrawer.querySelectorAll(
    '.menu-drawer__inner-submenu li > details'
  );

  childMenus.forEach((menu) => {
    menu.addEventListener('toggle', function () {
      if (!this.open) return;

      const parentSubmenu = this.closest('.menu-drawer__inner-submenu');

      parentSubmenu.querySelectorAll('li > details').forEach((other) => {
  if (other !== this && other.open) {
    const content = other.querySelector('summary').nextElementSibling;

    if (content) {
      content.style.height = content.scrollHeight + 'px';

      requestAnimationFrame(() => {
        content.style.height = '0px';
      });

      content.addEventListener(
        'transitionend',
        () => {
          other.removeAttribute('open');
        },
        { once: true }
      );
    }
  }
});
    });
  });

});

document.querySelectorAll('.menu-drawer details').forEach((details) => {
  const summary = details.querySelector('summary');
  const content = summary.nextElementSibling;

  if (!content) return;

  content.style.overflow = 'hidden';
  content.style.height = details.open ? 'auto' : '0px';
  content.style.transition = 'height 0.3s ease';

  summary.addEventListener('click', (e) => {
    e.preventDefault();

    if (details.open) {
      content.style.height = content.scrollHeight + 'px';

      requestAnimationFrame(() => {
        content.style.height = '0px';
      });

      content.addEventListener(
        'transitionend',
        () => {
          details.removeAttribute('open');
        },
        { once: true }
      );
    } else {
      details.setAttribute('open', '');

      content.style.height = '0px';

      requestAnimationFrame(() => {
        content.style.height = content.scrollHeight + 'px';
      });

      content.addEventListener(
        'transitionend',
        () => {
          content.style.height = 'auto';
        },
        { once: true }
      );
    }
  });
});

 